<template src="./TimeLineTareas.html"></template>

<script>
import seguimientoOverlay from "./seguimientoOverlay/seguimientoOverlay";
import {
  crearEncuentroSeguimiento,
  consultarListaCuestionario,
} from "../../../apiService/request/CrudSeguimiento";
import { eliminarSeguimiento } from "../../../apiService/request/CrudTareasPaciente";
import { eventosFiltradosTimeLine } from "../../../apiService/request/TimeLine";
import {
  crearFormulario,
  consultarFormularioLLenopacienteTerapia,
} from "../../../apiService/request/CrudFormulario";
import moment from "moment-timezone";
import { respuesta_leer } from "../../SubirArchivoV2/MocksSubirArchivoV2";
export default {
  data() {
    return {
      show: [],
      componenteKey: 0,
      copia: [],
      overlay: false,
      seguimiento: null,
      idSeguimiento: null,
      ultimoSeguimiento: null,
      fechaActual: new Date(),
      nombreFormulario: null,
      idFormulario: null,
      variablesFormulario: null,
      coleccion: null,
      texto_introductorio: null,
      contenedorTareas: 0,
      listaFormularios: [],
      tareaDe: "",
    };
  },
  props: {
    datosTareasPendientes: {
      type: Object,
      default: {},
    },
    consultando: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    seguimientoOverlay,
  },
  created() {},
  mounted() {},

  methods: {
    mostrarTarjeta(i) {
      this.show[i] = !this.show[i];
      this.forceRerender();
    },
    forceRerender() {
      this.componenteKey += 1;
    },
    async tareaSeleccionada(tareaDe, formulario) {
      try {
        this.$store.dispatch("setCargando", true);
        this.nombreFormulario = formulario;
        this.tareaDe =
          tareaDe === "paciente"
            ? "Seguimiento virtual"
            : "Seguimiento principal";
        this.seguimiento = `F: ${formulario}`;
        await this.creaSeguimiento();
      } catch (error) {
      } finally {
        this.overlay = true;
      }
    },
    // async tareaSeleccionada(tareaDe, formulario) {
    //   try {
    //     this.$store.dispatch("setCargando", true);
    //     this.nombreFormulario = formulario;
    //     this.seguimiento =
    //       tareaDe === "paciente"
    //         ? "Seguimiento virtual"
    //         : "Seguimiento principal";
    //     await this.consultarEncuentrosSeguimientos();
    //   } catch (error) {
    //   } finally {
    //     this.overlay = true;
    //   }
    // },

    //Función para buscar los últimos seguimientos.
    async consultarEncuentrosSeguimientos() {
      try {
        const response = await eventosFiltradosTimeLine(
          ["seguimientos"],
          Number(this.$store.getters.getCedulaPaciente),
          5
        );
        this.ultimoSeguimiento = response.data.data;
        // this.compararFechaSeguimiento();
      } catch (error) {
        console.log(error);
      }
    },
    //Función para comparar la fecha de los últimos seguimientos y si coincide con el mismo día no crear uno nuevo.
    compararFechaSeguimiento() {
      let seguimientoExiste = false;
      if (this.ultimoSeguimiento.length > 0) {
        this.ultimoSeguimiento.forEach((e) => {
          if (
            e.fecha.substring(0, 15) ===
              moment(this.fechaActual)
                .locale("es")
                .format("DD MMM [de] YYYY", "America/Bogota", "x") &&
            e.nombre === this.seguimiento
          ) {
            seguimientoExiste = true;
            this.idSeguimiento = e.docId;
          }
        });
      }

      if (seguimientoExiste) {
        this.crearFormulario();
      } else {
        this.creaSeguimiento();
      }
    },
    async creaSeguimiento() {
      let response = null;
      try {
        response = await crearEncuentroSeguimiento(
          this.seguimiento,
          this.$store.getters.getCedulaPaciente,
          this.$store.state.provider_email
        );
        if (response && response.data && response.data.data) {
          this.idSeguimiento = response.data.data.docId;
        }
      } catch (error) {
        console.log(error);
      } finally {
        if (response.data.status === 500) {
          alert(
            `No existe el seguimiento, el formulario se creará en el ${this.tareaDe}`
          );
          // this.$store.dispatch("setCargando", false);
          this.asignarNombreSeguimiento();
        } else {
          await this.crearFormulario();
        }
      }
    },
    async asignarNombreSeguimiento() {
      try {
        this.seguimiento = this.tareaDe;
        await this.creaSeguimiento();
      } catch (error) {}
    },
    async crearFormulario() {
      try {
        const response = await crearFormulario(
          "formularios",
          this.nombreFormulario,
          this.$store.state.provider_email,
          "momento1",
          Number(this.$store.getters.getCedulaPaciente),
          "seguimientos",
          this.idSeguimiento
        );
        if (response && response.data && response.data.data) {
          this.idFormulario = response.data.data.docId;
          await this.leerFormulario();
        }
      } catch (error) {}
    },

    async leerFormulario() {
      try {
        const response = await consultarFormularioLLenopacienteTerapia(
          this.nombreFormulario,
          this.idFormulario
        );
        if (response && response.data && response.data.data) {
          this.variablesFormulario = response.data.data.variables;
          this.nombreFormulario = response.data.data.key;
          this.coleccion = response.data.data.coleccion;
          if (response.data.data.texto_introductorio) {
            this.texto_introductorio = response.data.data.texto_introductorio;
          } else {
            this.texto_introductorio = null;
          }
        }
      } catch (error) {}
    },
    async cerrarFormularioSinActualizar() {
      try {
        let hayFormularios = false;
        await this.verificarFormulariosEnSeguimiento();
        this.listaFormularios.forEach((e) => {
          if (e.completado !== "") {
            hayFormularios = true;
          }
        });
        if (hayFormularios) {
          this.limpiarDataFormularios();
          this.overlay = false;
        } else {
          this.eliminarElSeguimiento();
          this.overlay = false;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.$store.dispatch("setCargando", false);
      }
    },
    async verificarFormulariosEnSeguimiento() {
      try {
        const respuesta = await consultarListaCuestionario(
          this.seguimiento,
          this.idSeguimiento
        );
        this.listaFormularios = respuesta.data.data.dataCuestionarios;
      } catch (err) {
        console.log(err);
      }
    },
    async eliminarElSeguimiento() {
      try {
        const response = await eliminarSeguimiento(this.idSeguimiento);
      } catch (error) {
        console.log(error);
      } finally {
      }
    },
    limpiarDataFormularios() {
      this.variablesFormulario = null;
      this.nombreFormulario = null;
      this.coleccion = null;
      this.texto_introductorio = null;
      this.ultimoSeguimiento = null;
      this.$emit("actualizarData");
    },
  },
};
</script>

<style src="./TimeLineTareas.scss" lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/TimeLine/TimeLineTareas/TimeLineTareas.vue